class c {
  static async syncId(i) {
    const t = await fetch(`https://uuid.jackbox.tv/image.png?origin=${i}`, {
      method: "GET",
      credentials: "include",
      // allow sending and receiving cookies
      headers: {
        Accept: "application/json"
      }
    });
    if (!t.ok)
      return;
    const s = (await t.json()).jbg_id;
    if (!s)
      return;
    const e = /* @__PURE__ */ new Date();
    e.setFullYear(e.getFullYear() + 1), document.cookie = `jbg_id=${s}; path=/; SameSite=Lax; Secure; expires=${e.toUTCString()}`;
  }
}
export {
  c as Uuid
};
